import React from 'react';
import { BackButton, ContinueButton } from '../components/common/navigation-buttons-v2';
import { EmailList } from './email-list';
import * as cs from './styles';

export function ErrorView({ visible, hideModal, goToMainMenu }) {
  return (
    <cs.WhiteModal hideBackdrop open={visible}>
      <cs.ViewContainer>
        <cs.ErrorHeader style={{ fontSize: '50px' }} size="huge">
          Something went wrong
        </cs.ErrorHeader>

        <cs.ErrorHeader>
          There was an unexpected server error. Please try again later.
          <br />
          If the problem persists, please contact us at{' '}
          <EmailList emails="str@placer.ca.gov" />
        </cs.ErrorHeader>

        <cs.TightButtonWrapper>
          {hideModal && <ContinueButton label="Try again" onClick={hideModal} />}
          <BackButton width="200px" label="Return to main menu" onClick={goToMainMenu} />
        </cs.TightButtonWrapper>

        <img src="../../assets/error-page.svg" alt="Multiple homes lined up" />
      </cs.ViewContainer>
    </cs.WhiteModal>
  );
}
